<template>
  <div class="content">
    <div class="notice-title" v-if="type=='1'">
    	<p>通知公告</p>
    	<!-- <p><span @click="goindex">首页-></span><span @click="goback">通知公告</span></p> -->
    </div>
     <div class="notice-title" v-if="type=='2'">
    	<p>政策文件</p>
    	<p><span @click="goindex">首页-></span><span @click="goback">政策文件</span></p>
    </div>
    <div class="notice-detail">
    	<h4 class="notice-bt">{{sj.titile}}</h4>
    	<div class="notice-two">
    		<p>
    			<span>发布时间：{{sj.createTime}}</span>
    			<!--<span>来源：</span>-->
    		</p>
    	</div>
    	<div v-if="sj.msgAbstract!='' && sj.msgAbstract!=null">
    		<iframe ref="iframe" width="100%" :src="geturl(sj.msgAbstract)" name="123" scrolling-y="auto" frameborder="0" style="width: 100%; height: 800px; background: #fff"></iframe>
    	</div>
    	<div v-else v-html="sj.msgContent" class="mbtom"></div> 
    </div>
  </div>
</template>

<script>
import { getNoticeDetail} from "@/api/index";
import { baseURL } from "@/utils/request.js";
export default {
  name: "DeclarationWebDetail",
  data() {
    return {
    	id:'',
    	sj:{},
    	type:"1",
    };
  },
  created(){
  		this.id=this.$route.query.id;
  		// this.type=this.$route.query.type;
  		this.godetail();
  },
  mounted(){},
  methods: {
	geturl(url){
		if(url.indexOf('doc')!='-1' || url.indexOf('docx')!='-1'){
			let result = url.substring(0, url.lastIndexOf("."))
			return '/jeecg-boot/'+result+".pdf"
		}else{
			return '/jeecg-boot/'+url
		}
	},
  	goindex(){
  		this.$router.replace({path:'/home/index1'});
  	},
  	goback(){
  		// this.$router.push({path:'noticeList',type:this.type});
		this.$router.push({name:'noticeList',query:{type:this.type}});
		  
  	},
  	godetail(){
  		let params={
  	     id:this.id,
  		};
  		getNoticeDetail(params).then((res) => {
					
	        if (res.code == '0') {
               this.sj=res.result;
               
	        }
      });
  	}
  },
};
</script>

<style lang="scss" scoped>
.content{
    width: 1200px;
    margin: 0 auto 20px;
}
.notice-title {
  font-size: 24px;
  font-weight: bold;
//   color: #9A0B00;
//   border-bottom: 1px solid #214cd9;
  color: #5D1000;
  border-bottom: 1px solid #9A0B00;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  p{
  	margin-bottom:0px;
  }
  span{
  	 color: #000000;
     font-size: 14px;
     font-variant: tabular-nums;
     font-weight: normal;
     cursor: pointer;
  }
  span:hover{
  	color: #9A0B00;
  }
}
.notice-detail{
    margin-top: 66px;
    color: #000000;
}
.notice-bt{
height: 32px;
font-size: 32px;
font-weight: 400;
color: #000000;
line-height: 35px;
margin-top: 30px;
text-align: center;
}
.notice-two{
	margin:30px 0px 20px;
	line-height: 30px;
	p{
		width:200px;
		height:30px;
		margin:0px auto;
		display: flex;
		justify-content: space-around;
		align-items: center;
		span{
			font-size: 14px;
			font-weight: 400;
			color: #666666;
			line-height: 35px;
		}
	}
}
.mbtom{
	margin-bottom: 60px;
}
</style>